<template>
  <PasswordConfigurationMulti
    v-model="item"
    :icon="$options.config.icon"
    :instructions="$options.config.instructions"
    :optionsAccountLockout="$options.config.optionsAccountLockout"
    :optionsPasswordExpiration="$options.config.optionsPasswordExpiration"
    :title="$options.config.title"
  />
</template>

<script>
import {
  ItemTypeConsts,
  ItemTypeDisplayNames,
} from 'client/util/Constants';
import PasswordConfigurationMulti from 'client/settings/Security/PasswordConfigurationMulti.vue';

const config = {
  icon: 'google',
  instructions: `Suspended users don't receive emails in ${ItemTypeDisplayNames[ItemTypeConsts.gSuite]}. To prevent users from logging in, but allow their account to receive emails, select Remove access. When this option is selected users aren't suspended and can regain access by resetting their password.`,
  optionsAccountLockout: [
    { label: 'Maintain users', value: 'maintain' },
    { label: 'Suspend users', value: 'suspend' },
  ],
  optionsPasswordExpiration: [
    { label: 'Maintain users', value: 'maintain' },
    { label: 'Suspend users', value: 'suspend' },
    { label: 'Remove access', value: 'remove_access' },
  ],
  title: ItemTypeDisplayNames[ItemTypeConsts.gSuite],
};

export default {
  name: 'PasswordConfigurationGoogle',

  components: {
    PasswordConfigurationMulti,
  },

  props: {
    value: {
      type: Array,
      default: () => ([]),
    },
  },

  computed: {
    item: {
      get() {
        return this.value;
      },
      set(newValue) {
        this.$emit('input', newValue);
      },
    },
  },

  config,
};
</script>
